<div [style]="containerStyle">
  <div
    *ngIf="reportPage"
    [attr.id]="reportPage.getAnchorId()"
    (click)="onClick($event)"
    [style]="reportPageStyle + pageStyle"
    [style.width]="reportPage.paperWidth"
    [style.height]="reportPage.paperHeight"
    [style.padding-top]="reportPage.paddingTop"
    [style.padding-bottom]="reportPage.paddingBottom"
    [style.padding-left]="reportPage.paddingLeft"
    [style.padding-right]="reportPage.paddingRight"
    [style.font-family]="fontFamily"
    [style.font-size]="fontSize"
  >
    <ng-container *ngIf="showDraftWatermark">
      <img
        class="draft-img"
        [src]="getDraftImage()"
        [style]="draftImageStyle"
        [style.z-index]="getPageMaxZIndex() + 1"
        [style.pointer-events]="'none'"
      />
    </ng-container>

    <section *ngIf="reportPage.hasHeader" [style]="headerStyle" [style.height]="reportPage.headerHeight">
      <canvas
        *ngIf="reportPage.isDrawMode"
        [style]="ghostLayerStyle"
        [attr.width]="getCanvasWidth()"
        [attr.height]="getCanvasHeight('Header')"
      ></canvas>

      <div [style]="previewLayerStyle">
        <app-report-text-container-offline
          [style]="componentOuterStyle"
          *ngFor="let textKey of headerTextKeys"
          [pageKey]="pageKey"
          [textKey]="textKey"
          [elementLocation]="'Header'"
        >
        </app-report-text-container-offline>
        <app-report-line-container-offline
          [style]="componentOuterStyle"
          *ngFor="let lineKey of headerLineKeys"
          [pageKey]="pageKey"
          [lineKey]="lineKey"
          [elementLocation]="'Header'"
        >
        </app-report-line-container-offline>
        <app-report-image-container-offline
          [style]="componentOuterStyle"
          *ngFor="let imageKey of headerImageKeys"
          [pageKey]="pageKey"
          [imageKey]="imageKey"
          [elementLocation]="'Header'"
        >
        </app-report-image-container-offline>
        <app-report-rectangle-container-offline
          [style]="componentOuterStyle"
          *ngFor="let rectangleKey of headerRectangleKeys"
          [pageKey]="pageKey"
          [rectangleKey]="rectangleKey"
          [elementLocation]="'Header'"
        >
        </app-report-rectangle-container-offline>
        <app-report-summary-container-offline
          [style]="componentOuterStyle"
          *ngFor="let summaryKey of headerSummaryKeys"
          [pageKey]="pageKey"
          [summaryKey]="summaryKey"
          [elementLocation]="'Header'"
        >
        </app-report-summary-container-offline>
        <app-report-picture-container-offline
          [style]="componentOuterStyle"
          *ngFor="let pictureKey of headerPictureKeys"
          [pageKey]="pageKey"
          [pictureKey]="pictureKey"
          [elementLocation]="'Header'"
        >
        </app-report-picture-container-offline>
        <app-report-signature
          [style]="componentOuterStyle"
          *ngFor="let signatureKey of headerSignatureKeys"
          [pageKey]="pageKey"
          [signatureKey]="signatureKey"
          [elementLocation]="'Header'"
        >
        </app-report-signature>
        <app-report-table
          [style]="componentOuterStyle"
          *ngFor="let tableKey of headerTableKeys"
          [pageKey]="pageKey"
          [tableKey]="tableKey"
          [elementLocation]="'Header'"
        >
        </app-report-table>
      </div>
    </section>

    <section [style]="bodyStyle" [style.height]="reportPage.bodyHeight">
      <canvas
        *ngIf="reportPage.isDrawMode"
        [style]="ghostLayerStyle"
        [attr.width]="getCanvasWidth()"
        [attr.height]="getCanvasHeight('Body')"
      ></canvas>

      <div [style]="previewLayerStyle">
        <app-report-section
          [style]="componentOuterStyle"
          *ngFor="let sectionKey of sectionKeys"
          [pageKey]="pageKey"
          [sectionKey]="sectionKey"
          [elementLocation]="'Body'"
        ></app-report-section>
        <app-report-text-container-offline
          *ngFor="let textKey of bodyTextKeys"
          [pageKey]="pageKey"
          [textKey]="textKey"
          [elementLocation]="'Body'"
          [tableData]="reportPage.pictureDataList"
        >
        </app-report-text-container-offline>
        <app-report-line-container-offline
          [style]="componentOuterStyle"
          *ngFor="let lineKey of bodyLineKeys"
          [pageKey]="pageKey"
          [lineKey]="lineKey"
          [elementLocation]="'Body'"
        >
        </app-report-line-container-offline>
        <app-report-image-container-offline
          [style]="componentOuterStyle"
          *ngFor="let imageKey of bodyImageKeys"
          [pageKey]="pageKey"
          [imageKey]="imageKey"
          [elementLocation]="'Body'"
        >
        </app-report-image-container-offline>
        <app-report-rectangle-container-offline
          [style]="componentOuterStyle"
          *ngFor="let rectangleKey of bodyRectangleKeys"
          [pageKey]="pageKey"
          [rectangleKey]="rectangleKey"
          [elementLocation]="'Body'"
        >
        </app-report-rectangle-container-offline>
        <app-report-summary-container-offline
          [style]="componentOuterStyle"
          *ngFor="let summaryKey of bodySummaryKeys"
          [pageKey]="pageKey"
          [summaryKey]="summaryKey"
          [elementLocation]="'Body'"
          [tableData]="reportPage.summaryDataList"
          [isFirst]="reportPage.summaryFirst"
        >
        </app-report-summary-container-offline>
        <app-report-picture-container-offline
          [style]="componentOuterStyle"
          *ngFor="let pictureKey of bodyPictureKeys"
          [pageKey]="pageKey"
          [pictureKey]="pictureKey"
          [elementLocation]="'Body'"
          [tableData]="reportPage.pictureDataList"
          [isFirst]="reportPage.pictureFirst"
        >
        </app-report-picture-container-offline>
        <app-report-dataplate-container-offline
          [style]="componentOuterStyle"
          *ngFor="let dataPlateKey of bodyDataPlateKeys"
          [pageKey]="pageKey"
          [dataPlateKey]="dataPlateKey"
          [elementLocation]="'Body'"
          [images]="reportPage.dataPlateDataList"
          [isFirst]="reportPage.dataPlateFirst"
        >
        </app-report-dataplate-container-offline>
        <app-report-measurement-points
          [style]="componentOuterStyle"
          *ngFor="let measurementPointKey of bodyMeasurementPointKey"
          [pageKey]="pageKey"
          [measurementPointKey]="measurementPointKey"
          [elementLocation]="'Body'"
        ></app-report-measurement-points>
        <app-visual-events
          [style]="componentOuterStyle"
          *ngFor="let visualEventsKey of bodyVisualEventsKeys"
          [pageKey]="pageKey"
          [visualEventsKey]="visualEventsKey"
          [elementLocation]="'Body'"
        ></app-visual-events>
        <app-report-signature
          [style]="componentOuterStyle"
          *ngFor="let signatureKey of bodySignatureKeys"
          [pageKey]="pageKey"
          [signatureKey]="signatureKey"
          [elementLocation]="'Body'"
        >
        </app-report-signature>
        <app-report-table
          [style]="componentOuterStyle"
          *ngFor="let tableKey of bodyTableKeys"
          [pageKey]="pageKey"
          [tableKey]="tableKey"
          [elementLocation]="'Body'"
        >
        </app-report-table>
        <app-report-iso
          [style]="componentOuterStyle"
          *ngFor="let isoKey of bodyInteractiveIsoKeys"
          [pageKey]="pageKey"
          [isoKey]="isoKey"
          [elementLocation]="'Body'"
        >
        </app-report-iso>
        <app-report-dropdown-list
          [style]="componentOuterStyle"
          *ngFor="let dropDownListKey of bodyDropDownListKeys"
          [pageKey]="pageKey"
          [dropDownListKey]="dropDownListKey"
          [elementLocation]="'Body'"
        >
        </app-report-dropdown-list>
        <app-report-custom-element
          [style]="componentOuterStyle"
          *ngFor="let customElementKey of bodyCustomElementsKeys"
          [pageKey]="pageKey"
          [customElementsKey]="customElementKey"
          [elementLocation]="'Body'"
        >
        </app-report-custom-element>
      </div>
    </section>

    <section *ngIf="reportPage.hasFooter" [style]="footerStyle" [style.height]="reportPage.footerHeight">
      <canvas
        *ngIf="reportPage.isDrawMode"
        [style]="ghostLayerStyle"
        [attr.width]="getCanvasWidth()"
        [attr.height]="getCanvasHeight('Footer')"
      ></canvas>

      <div [style]="previewLayerStyle">
        <app-report-text-container-offline
          [style]="componentOuterStyle"
          *ngFor="let textKey of footerTextKeys"
          [pageKey]="pageKey"
          [textKey]="textKey"
          [elementLocation]="'Footer'"
        >
        </app-report-text-container-offline>
        <app-report-line-container-offline
          [style]="componentOuterStyle"
          *ngFor="let lineKey of footerLineKeys"
          [pageKey]="pageKey"
          [lineKey]="lineKey"
          [elementLocation]="'Footer'"
        >
        </app-report-line-container-offline>
        <app-report-image-container-offline
          [style]="componentOuterStyle"
          *ngFor="let imageKey of footerImageKeys"
          [pageKey]="pageKey"
          [imageKey]="imageKey"
          [elementLocation]="'Footer'"
        >
        </app-report-image-container-offline>
        <app-report-rectangle-container-offline
          [style]="componentOuterStyle"
          *ngFor="let rectangleKey of footerRectangleKeys"
          [pageKey]="pageKey"
          [rectangleKey]="rectangleKey"
          [elementLocation]="'Footer'"
        >
        </app-report-rectangle-container-offline>
        <app-report-summary-container-offline
          [style]="componentOuterStyle"
          *ngFor="let summaryKey of footerSummaryKeys"
          [pageKey]="pageKey"
          [summaryKey]="summaryKey"
          [elementLocation]="'Footer'"
        >
        </app-report-summary-container-offline>
        <app-report-picture-container-offline
          [style]="componentOuterStyle"
          *ngFor="let pictureKey of footerPictureKeys"
          [pageKey]="pageKey"
          [pictureKey]="pictureKey"
          [elementLocation]="'Footer'"
        >
        </app-report-picture-container-offline>
        <app-report-dataplate-container-offline
          [style]="componentOuterStyle"
          *ngFor="let dataPlateKey of footerDataPlateKeys"
          [pageKey]="pageKey"
          [dataPlateKey]="dataPlateKey"
          [elementLocation]="'Footer'"
        >
        </app-report-dataplate-container-offline>
        <app-report-signature
          [style]="componentOuterStyle"
          *ngFor="let signatureKey of footerSignatureKeys"
          [pageKey]="pageKey"
          [signatureKey]="signatureKey"
          [elementLocation]="'Footer'"
        >
        </app-report-signature>
        <app-report-table
          [style]="componentOuterStyle"
          *ngFor="let tableKey of footerTableKeys"
          [pageKey]="pageKey"
          [tableKey]="tableKey"
          [elementLocation]="'Footer'"
        >
        </app-report-table>
      </div>
    </section>
  </div>
</div>
